export const genderShort = {
    men: "M",
    women: "F",
};

export const gender = {
    men: "Men",
    women: "Women",
};
